import { DetailsDisplayMode, PaginationMode, SearchViewDisplayMode, GridColumnsPreset } from "@/user-preferences/enums";
import { extractColumnDisplayPreferences } from "@/lib/extract-columns-preferences";
import { site_role_user_column_display_seeds } from "./column-display-seeds";

export const siteRoleUserDefaultUserPreferences = {
    availableDisplayModes: [SearchViewDisplayMode.LIST, SearchViewDisplayMode.GRID, SearchViewDisplayMode.TABLE],
    detailsDisplayMode: DetailsDisplayMode.PANEL,
    table: {
        fontSize: 14,
        defaultItemsPerPage: 50,
        displayItemsPerPageSelector: true,
        paginationMode: PaginationMode.PAGED,
        verticalPadding: 12,
        zebraLines: false,
        showVerticalLines: false,
        showHorizontalLines: true,
        wrapText: false,
        columns: extractColumnDisplayPreferences(site_role_user_column_display_seeds),
    },
    grid: {
        masonryStyle: false,
        availableGridColumns: [
            GridColumnsPreset.AUTO_200,
            GridColumnsPreset.AUTO_250,
            GridColumnsPreset.AUTO_300,
            GridColumnsPreset.AUTO_400,
        ],
        gridColumns: GridColumnsPreset.AUTO_250,
    },
    viewCustom: {},
};
